
export class AppSettings {


    // FOR NEW DEV

    // public static API_ENDPOINT = 'https://mascdevapi82.webspiders.com/';

    // public static REDIRECT_LOGIN = "https://mascdevapi82.webspiders.com/autologin.php";

    // public static CMS_ENDPOINT = 'https://mascdev.webspiders.com/';

    // public static PORTAL_ENDPOINT = 'https://mmeportal.webspiders.com/';

    // public static GA_ID = '';

    // public static GTM_ID = '';

    // public static FILE_UPLOADERPATH = 'https://gotouat.mitsubishi-motors.eu/';

   // FOR DEV

  //  public static API_ENDPOINT='https://masc.webspiders.com/';

  //  public static REDIRECT_LOGIN = "https://masc.webspiders.com/autologin.php";

  //  public static CMS_ENDPOINT='https://masc.webspiders.com/public_html';

  //  public static PORTAL_ENDPOINT='https://mmeportal.webspiders.com/';

  //   public static GA_ID ='';
    
  //   public static GTM_ID ='';

  //  public static FILE_UPLOADERPATH = 'https://gotouat.mitsubishi-motors.eu/';


   

   // FOR Client  UAT

    // public static API_ENDPOINT='https://mascuatapi.mitsubishi-motors.eu/';
    
    // public static REDIRECT_LOGIN = "https://mascuatapi.mitsubishi-motors.eu/autologin.php";
    
    // public static CMS_ENDPOINT='https://mascuat.mitsubishi-motors.eu/';

    // public static PORTAL_ENDPOINT='https://portaluat.mitsubishi-motors.eu/';

    // public static GA_ID ='';
    
    // public static GTM_ID ='';
     
    // public static FILE_UPLOADERPATH = 'https://gotouat.mitsubishi-motors.eu/';



   // FOR PRD

     public static API_ENDPOINT='https://mascapi.mitsubishi-motors.eu/';
     
     public static REDIRECT_LOGIN = "https://mascapi.mitsubishi-motors.eu/autologin.php";
     
     public static CMS_ENDPOINT='https://masc.mitsubishi-motors.eu/';

    public static PORTAL_ENDPOINT='https://portal.mitsubishi-motors.eu/';

     public static GA_ID ='UA-187906404-1';

     public static GTM_ID ='GTM-MB8SDGQ';

    public static FILE_UPLOADERPATH = 'https://goto.mitsubishi-motors.eu/';


}
